import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createSlots as _createSlots, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bba54a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination-container" }

import type { TableColumnsType } from 'ant-design-vue'
import { type PropType, ref, useSlots, watch } from 'vue'
import { type Key, type MyObject, type Pagination as PaginationType } from './types'
import { type TablePaginationConfig } from 'ant-design-vue/es/table/Table'
import { type ColumnType, type FilterValue, type SorterResult } from 'ant-design-vue/es/table/interface'
import {
  Table,
  Pagination,

} from "ant-design-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  needSummary: {
    type: Boolean,
    default: false,
  },
  totalLine: {
    type: Object as PropType<MyObject>,
    default: () => ({}),
  },
  tableHeight: {
    type: [String, Number],
    default: '100%',
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  tableData: {
    type: Array,
    default: () => [],
  },
  showPagination: {
    type: Boolean,
    default: true,
  },
  columns: {
    type: Array as PropType<TableColumnsType>,
    default: () => [],
  },
  showRowSelection: {
    type: Boolean,
    default: false,
  },
  preserveSelectedRowKeys: {
    type: Boolean,
    default: true,
  },
  rowKey: {
    type: String,
    default: 'id',
  },
  selectionType: {
    type: String,
    default: 'checkbox',
  },
  selectedRowKeys: {
    type: Array as PropType<number[] | string[]>,
    default: () => ([]),
  },
  pagination: {
    type: Object as PropType<PaginationType>,
    default: () => ({}),
  },
},
  emits: [
  'changePage', 'changeTable', 'selectChange', 'updatePagination',
],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit
const pageSizeOptions = ref<string[]>(['10', '20', '50', '100', '200'])
const selectedRowKeysState = ref<Key[]>()

const getCheckboxProps = (record: { disabled: boolean }) => {
  return {
    disabled: record.disabled,
  }
}

const onShowSizeChange = (_current: number, pageSize: number) => {
  Object.assign(props.pagination, {
    pageSize,
  })
}

watch(() => props.selectedRowKeys, (arr) => {
  selectedRowKeysState.value = arr
}, {
  immediate: true,
  deep: true,
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onSelectChange = (selectedRowKeys: Key[], selectedRows: any[]) => {
  selectedRowKeysState.value = selectedRowKeys

  emits('selectChange', selectedRowKeys, selectedRows)
}
const slots = useSlots()

const slotKeys = Object.keys(slots)

const onChangePage = (page: number, pageSize: number) => {
  emits('changePage', page, pageSize)
}

const onChangeTable = (
  pagination: TablePaginationConfig,
  filters: Record<string, FilterValue | null>,
  sorter: SorterResult,
) => {
  emits('changeTable', sorter, pagination, filters)
}

const handleResizeColumn = (w: number, col: ColumnType) => {
  col.width = w
}


return (_ctx: any,_cache: any) => {
  const _component_a_table_summary_cell = _resolveComponent("a-table-summary-cell")!
  const _component_a_table_summary_row = _resolveComponent("a-table-summary-row")!
  const _component_a_table_summary = _resolveComponent("a-table-summary")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Table), {
      columns: __props.columns,
      "data-source": __props.tableData,
      loading: __props.isLoading,
      pagination: false,
      "row-key": __props.rowKey,
      "row-selection": __props.showRowSelection ?
      {
        selectedRowKeys: selectedRowKeysState.value,
        onChange: onSelectChange,
        type: __props.selectionType,
        getCheckboxProps: getCheckboxProps,
        preserveSelectedRowKeys: __props.preserveSelectedRowKeys
      }: undefined,
      scroll: { x: '100%', y: __props.tableHeight },
      onChange: onChangeTable,
      onResizeColumn: handleResizeColumn
    }, _createSlots({ _: 2 }, [
      _renderList(_unref(slotKeys), (item) => {
        return {
          name: item,
          fn: _withCtx((scope) => [
            _renderSlot(_ctx.$slots, item, _normalizeProps(_guardReactiveProps(scope)))
          ])
        }
      }),
      (__props.needSummary)
        ? {
            name: "summary",
            fn: _withCtx(() => [
              _createVNode(_component_a_table_summary, { fixed: "top" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_table_summary_row, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (item, idx) => {
                        return (_openBlock(), _createBlock(_component_a_table_summary_cell, {
                          key: item,
                          index: idx
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.totalLine[item.dataIndex] ?? '-'), 1)
                          ]),
                          _: 2
                        }, 1032, ["index"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["columns", "data-source", "loading", "row-key", "row-selection", "scroll"]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Pagination), {
        current: __props.pagination.page,
        "page-size": __props.pagination.pageSize,
        "page-size-options": pageSizeOptions.value,
        "show-quick-jumper": "",
        "show-size-changer": "",
        "show-total": total => `共${total}条`,
        total: __props.pagination.total,
        onChange: onChangePage,
        onShowSizeChange: onShowSizeChange
      }, null, 8, ["current", "page-size", "page-size-options", "show-total", "total"])
    ], 512), [
      [_vShow, __props.showPagination && __props.pagination.total > __props.pagination.pageSize]
    ])
  ], 64))
}
}

})